import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as Actions from './actions';

const Contract = Record({
    title: null,
    description: null,
    body: null,
    file: null,
    for: null,
    token: null,
    status: null,
});

export const contractFromApi = data => new Contract(data);

const State = Record({
    fetching: false,
    accepting: false,
    accepted: false,
    showAcceptedModal: false,
    contract: null,
});

export default handleActions(
    {
        [Actions.fetchContract.type]: () =>
            new State({
                fetching: true,
            }),
        [Actions.fetchContractSuccess.type]: (state, {payload}) =>
            state.merge({
                fetching: false,
                contract: payload.contract,
            }),
        [Actions.fetchContractFailed.type]: state =>
            state.merge({
                fetching: false,
            }),
        [Actions.acceptContract.type]: state =>
            state.merge({
                accepting: true,
            }),
        [Actions.acceptContractSuccess.type]: state =>
            state.merge({
                accepting: false,
                accepted: true,
                showAcceptedModal: true,
            }),
        [Actions.acceptContractFailed.type]: state =>
            state.merge({
                accepting: false,
            }),
        [Actions.showAcceptedModal.type]: (state, {payload}) =>
            state.merge({
                showAcceptedModal: payload.show,
            }),
    },
    new State(),
);
